import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CommonService} from '../../../services/common.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-announcements-display',
  templateUrl: './announcements-display.component.html',
  styleUrls: ['./announcements.component.scss']
})


export class AnnouncementsDisplayComponent implements OnInit   {
  id: number;
  isLoading: boolean;
  announcement: any;
  pageTitle: string;
  htmlContent: any;
  uniqueId: string;
  editorStylePreview: any;
  @ViewChild('divElement', {static: false}) divElement: ElementRef;

  constructor(private sanitized: DomSanitizer, public route: ActivatedRoute, private commonService: CommonService,
              private renderer: Renderer2, public toastMessagesService: ToastMessagesService) {
    this.isLoading = true;
    this.editorStylePreview = {height: '100%;', border: '0px'};

  }

  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(async (params) => {
      this.id = params.id;
      this.uniqueId = params.unique_id;
      const title = params.title;
      let error = false;
      await this.updateOpenedAnnouncement();
      try {
        // const announcementRequest = await this.commonService.getList(`people/parents/announcements?id=${this.id}`);
        const announcementRequest = await this.commonService.getList(`forms/content?uniqueId=${this.uniqueId}`);
        this.announcement = announcementRequest.object[0];
        // Add title from query params since forms/content doesn't return it
        this.announcement.title = title || 'Ανακοίνωση';
        console.log(this.announcement);
      } catch (e) {
        this.announcement = { title: 'Δεν έχετε δικαίωμα να δείτε αυτή την ανακοίνωση' };
        error = true;
        console.log(e.message);
      } finally {

        if (!error) {
          const content = JSON.parse(this.announcement.content);
          this.htmlContent =  content.htmlContent;
          // this.renderer.setProperty(this.divElement.nativeElement, 'innerHTML', content.htmlContent);
        }

        this.isLoading = false;
      }

    });
  }


  async updateOpenedAnnouncement() {
    try {
      await this.commonService.updateItem(`people/parents/announcements?id=${this.id}`, {});
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }
}
